<script setup lang="ts">
import { useFormSection } from "../composables/useFormSection"

const props = defineProps<{
  id: string
  title: string
  description?: string
}>()

const section = useFormSection({
  id: props.id,
  title: props.title,
  description: props.description
})
</script>

<template>
  <section
    :id="id"
    :ref="(el) => { section.el.value = el as HTMLElement | null }"
    class="bg-base-100 border-y border-base-300 px-4 py-4
           lg:card lg:border-l-4 lg:border-primary lg:shadow-sm lg:border-y-0 lg:px-0 lg:py-0"
    style="scroll-margin-top: 5rem"
  >
    <div class="lg:card-body">
      <header class="mb-2 flex items-center gap-2">
        <span
          class="inline-block w-1.5 h-1.5 rounded-full bg-primary shrink-0 lg:hidden"
          aria-hidden="true"
        />
        <h2 class="text-primary text-sm font-semibold uppercase tracking-wide lg:card-title lg:text-base lg:normal-case lg:tracking-normal">
          {{ title }}
          <span
            v-if="section.hasError.value"
            class="badge badge-error badge-xs"
            aria-label="Sektion enthält Fehler"
          />
        </h2>
      </header>
      <p v-if="description" class="text-sm text-base-content/60 -mt-1 mb-2">{{ description }}</p>
      <div class="space-y-3 lg:space-y-4">
        <slot />
      </div>
    </div>
  </section>
</template>
